import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyC8Scm5LQ0zzkyUIKqmm94PjSvzf53S844",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "in-house-dev-mlc.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "in-house-dev-mlc",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "mlc-proposal-hq-storage",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "603286827661",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:603286827661:web:07a68bc4f5a611695b68c4",
};

// Initialize Firebase App singleton
export const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Auth setup
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  hd: "mlconnections.com",
  prompt: "select_account",
});

// CRITICAL: Explicitly connect to the named Firestore database (mlc-proposal-hq-db)
const firestoreDbName = import.meta.env.VITE_FIRESTORE_DB_NAME || "mlc-proposal-hq-db";
export const db = getFirestore(app, firestoreDbName);

// CRITICAL: Explicitly connect to the isolated storage bucket (mlc-proposal-hq-storage)
const storageBucketName = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "mlc-proposal-hq-storage";
export const storage = getStorage(app, `gs://${storageBucketName}`);

// Optional Emulator Connection for local testing and E2E
if (import.meta.env.VITE_USE_EMULATORS === "true") {
  const host = import.meta.env.VITE_EMULATOR_HOST || "localhost";
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, host, 8080);
  connectStorageEmulator(storage, host, 9199);
}
